import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateRestreamDestinationMutation } from "../graphql/mutations";
import type {
  UpdateRestreamDestinationMutationType,
  UpdateRestreamDestinationMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateRestreamDestinationMutation = (
  options?: MutationHookOptions<
    UpdateRestreamDestinationMutationType,
    UpdateRestreamDestinationMutationVariablesType
  >
) => {
  return useMutation<
    UpdateRestreamDestinationMutationType,
    UpdateRestreamDestinationMutationVariablesType
  >(UpdateRestreamDestinationMutation, options);
};
